import { Direction } from '@angular/cdk/bidi';
import { Component, Input, inject } from '@angular/core';
import { CONFIG } from '@nano/core/config';
import { L10nService } from '@nano/core/l10n';
import { PaymentStatusUI } from '@nano/payment-entry/payment-entry-status';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.less'],
  standalone: false
})
export class AvatarComponent {
  @Input() text: string;
  @Input() size = '40px';
  @Input() alert: string;
  @Input() displayWithText = false;
  @Input() icon: string;
  @Input() paymentStatus: PaymentStatusUI;
  @Input() responsive = false;

  direction: Direction;

  readonly additionalPaymentStatusIconsEnabled: boolean;

  private config = inject(CONFIG);

  constructor(private l10nService: L10nService) {
    this.additionalPaymentStatusIconsEnabled = this.config.additionalPaymentStatusIconsEnabled;

    this.l10nService.schema$
      .pipe(
        untilDestroyed(this),
        filter((schema) => !!schema)
      )
      .subscribe((schema) => (this.direction = schema.dir));
  }

  get displayPaymentStatusIcon(): boolean {
    return (
      this.additionalPaymentStatusIconsEnabled && [PaymentStatusUI.PENDING, PaymentStatusUI.DECLINED, PaymentStatusUI.UNDER_REVIEW].includes(this.paymentStatus)
    );
  }

  get hasNoIcon(): boolean {
    return !this.icon;
  }

  get hasNoText(): boolean {
    return !this.text || this.text === 'demo';
  }
}
